/* @jsx h */
import { defineComponent, h, PropType } from "vue";

export const RESERVATION_DURATION_OPTIONS = [
  { value: 30, label: "30 min" },
  { value: 45, label: "45 min" },
  { value: 60, label: "1h" },
  { value: 90, label: "1h 30" },
  { value: 120, label: "2h" },
  { value: 150, label: "2h 30" },
  { value: 180, label: "3h" },
  { value: 240, label: "4h" },
];

interface ReservationDurationFieldProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const ReservationDurationField =
  defineComponent<ReservationDurationFieldProps>({
    name: "ReservationDurationField",
    props: {
      value: {
        type: Number,
        required: true,
      },
      onChange: {
        type: Function as PropType<(value: number) => void>,
        required: true,
      },
      disabled: Boolean,
    },
    setup(props) {
      const optionValues = RESERVATION_DURATION_OPTIONS.map(
        (option) => option.value,
      );

      return () => {
        const currentIndex = optionValues.indexOf(props.value);
        const previousDisabled = props.disabled || currentIndex <= 0;
        const nextDisabled =
          props.disabled ||
          currentIndex === -1 ||
          currentIndex >= optionValues.length - 1;

        return (
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="w-7 h-7 rounded-lg border border-base-content/12 flex items-center justify-center text-base-content/50 hover:text-accent hover:border-base-content/25 active:scale-95 transition-all flex-shrink-0 disabled:opacity-30 disabled:hover:text-base-content/50 disabled:hover:border-base-content/12 disabled:active:scale-100"
              onClick={() => {
                if (previousDisabled) return;
                props.onChange(optionValues[currentIndex - 1]);
              }}
              disabled={previousDisabled}
            >
              <span class="material-symbols-outlined text-base">remove</span>
            </button>
            <span class="text-[13px] font-semibold text-accent w-[36px] text-center flex-shrink-0 whitespace-nowrap">
              {RESERVATION_DURATION_OPTIONS.find(
                (option) => option.value === props.value,
              )?.label || `${props.value}m`}
            </span>
            <button
              type="button"
              class="w-7 h-7 rounded-lg border border-base-content/12 flex items-center justify-center text-base-content/50 hover:text-accent hover:border-base-content/25 active:scale-95 transition-all flex-shrink-0 disabled:opacity-30 disabled:hover:text-base-content/50 disabled:hover:border-base-content/12 disabled:active:scale-100"
              onClick={() => {
                if (nextDisabled) return;
                props.onChange(optionValues[currentIndex + 1]);
              }}
              disabled={nextDisabled}
            >
              <span class="material-symbols-outlined text-base">add</span>
            </button>
          </div>
        );
      };
    },
  });
